import React from "react";
import { FaFilter } from "react-icons/fa";
import { ALL_PAYMENT_SITUATIONS } from "../shared/paymentListTypes";
import "./FilterSectionPayment.css";

interface FilterSectionProps {
  selectedSituation?: string[];
  handleSituationFilter: (value: string | string[]) => void;
  allSituations?: readonly string[];
}

const FilterSection = ({
  selectedSituation = [],
  handleSituationFilter,
  allSituations = ALL_PAYMENT_SITUATIONS,
}: FilterSectionProps) => {
  const situations = [...allSituations];
  const isAllSelected =
    situations.length > 0 &&
    situations.every((s) => selectedSituation.includes(s));

  const handleToggleAll = () => {
    if (isAllSelected) return handleSituationFilter([]);
    handleSituationFilter([...situations]);
  };

  const handleCheckboxChange = (label: string) => {
    handleSituationFilter(label);
  };

  return (
    <div className="filters-section">
      <div className="filter-label">
        <FaFilter style={{ marginRight: "5px" }} /> Filtro situação:
      </div>

      <div className="checkbox-grid">
        <div className="form-check form-check-inline">
          <input
            id="filter-payment-all"
            className="form-check-input"
            type="checkbox"
            checked={isAllSelected}
            onChange={handleToggleAll}
          />
          <label className="form-check-label" htmlFor="filter-payment-all">
            Todos
          </label>
        </div>

        {situations.map((label) => {
          const id = `filter-payment-${label.replace(/\s+/g, "-").toLowerCase()}`;
          return (
            <div className="form-check form-check-inline" key={label}>
              <input
                id={id}
                className="form-check-input"
                type="checkbox"
                checked={selectedSituation.includes(label)}
                onChange={() => handleCheckboxChange(label)}
              />
              <label className="form-check-label" htmlFor={id}>
                {label}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FilterSection;
